export default function  MMAMeeting() {
    return (
        <div className="accordion-item">
        <h2 className="accordion-header">
          <button className="accordion-button caret-off collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMMAMeeting">
            <div className="custom-button-layout">
            <img className="day-icon" src="../img/cal-icons/august-20-icon.png" alt="Aug 20 Calendar Icon" />
            <b>CANCELED: Municipal Authority Board Meeting
             </b>
             <span className="badge bg-danger">CANCELED</span> 
             {/*      <span className="badge bg-primary badge-custom">Meeting</span>  */}
            </div>
          </button>
        </h2>
        <div id="collapseMMAMeeting" className="accordion-collapse collapse" data-bs-parent="#upcomingEventsAccordion">
          <div className="accordion-body">
          <p>
            This meeting has been canceled.
            {/*  Monday, June 1, 2026 at 7:00 p.m.<br /> 
            <a href="https://maps.app.goo.gl/uB7NMgLow9j2wTka6">
              <i className="fa-solid fa-location-pin"></i>&nbsp;Morrisville Borough Hall (35 Union St.)
            </a>
            */}
          </p>
          </div>
        </div>
      </div>
    )
}